import { defineStore } from 'pinia';

import type { Claim } from '@stuut/api/models';

interface State {
  claims: Claim[];
}

export const useClaims = defineStore('claims', {
  getters: {
    getById: (state) => {
      return (claimId: string) =>
        state.claims.find((claim) => claim.id === claimId) as Claim | undefined;
    },
  },
  state: (): State => ({
    claims: [],
  }),
});

export default useClaims;
